//请自行添加语言资源
const reshipCorn = {
  plantName: '基地',
  planNo: '计划单号',
  orderNo: '作业单号',
  weighOrderNo: '过磅单号',
  goodsCategoryName: '货物类别',
  reshipDate: '倒运日期',
  lotNo: '批次',
  vehicleNo: '车牌号',
  driverUserNo: '司机姓名',
  driverTel: '司机手机号',
  planWeight: '计划倒运吨数',
  unpeelWeight: '毛重',
  peelWeight: '皮重',
  netWeight: '净重',
  currentNodeName: '车辆状态',
  originStorageName: '发出库位',
  destStorageName: '卸货库位',
  weigher: '司磅员',
  peelWeighEndTime: '轻车称重时间',
  originLoadEndUser: '开始装车保管确认操作人',
  originLoadBeginTime: '开始装车时间',
  originLoadEndTime: '结束装车时间',
  unpeelWeighEndTime: '重车称重时间',
  destUnloadBeginUser: '卸车接收确认操作人',
  destUnloadBeginTime: '卸车开始时间',
  destUnloadEndTime: '卸车完成时间'
};
export default reshipCorn



// WEBPACK FOOTER //
// ./src/page/report/reshipCornOrder/lang/reshipCorn.en.js